import { Button, Card } from '../ui/primitives';
import { MetaList } from '../ui/MetaList';
import type { CostsView } from '../../utils/reports/costsView';
import { ReportsNotes, ReportsSay } from './ReportsParts';
import { ReportsCardTitle, ReportsCoverage, ReportsDetail, ReportsEmpty, ReportsSection, ReportsStats } from './ReportsPieces';

/**
 * P-084 · R5 «¿Cómo van mis costos?». Solo dibuja `CostsView`: la frase (compuesta con cobertura, aproximado y
 * bloqueos), cuatro cifras, la barra de cobertura de dos partes, la mezcla por fuente como lista, la comparación, el
 * atajo del servidor y el detalle (costo por producto, insumos que cambiaron de precio).
 */
export function ReportCosts({ view, onNavigate }: { view: CostsView; onNavigate: (destination: string) => void }) {
  if (view.empty) {
    return (
      <>
        <ReportsSay segments={view.say} />
        <ReportsEmpty description={view.empty.description} title={view.empty.title} />
        <ReportsNotes notes={view.notes} />
      </>
    );
  }
  return (
    <>
      <ReportsSay segments={view.say} />
      <Card aria-labelledby="reports-costs-stats" as="section" className="n3-reports__section">
        <h2 className="n3-visually-hidden" id="reports-costs-stats">Costo de lo vendido, cobertura, margen conocido y comparación</h2>
        <ReportsStats stats={view.stats} />
        {view.coverage && <ReportsCoverage view={view.coverage} />}
        {view.comparison && <p className="n3-reports__comparison">{view.comparison}</p>}
        {view.cta && <Button className="n3-reports__cta" onClick={() => onNavigate(view.cta!.destination)} variant="primary">{view.cta.label}</Button>}
      </Card>
      {view.mix.length > 0 && (
        <Card aria-labelledby="reports-costs-mix" as="section" className="n3-reports__section">
          <ReportsCardTitle icon="coins" id="reports-costs-mix" tone="highlight">De dónde sale el costo</ReportsCardTitle>
          <MetaList aria-label="Venta por fuente del costo" items={view.mix.map((row) => ({ key: row.key, label: row.label, value: row.value }))} />
          <p className="n3-reports__panel-note">Es un desglose para leerse, no una partición exacta: una devolución puede hacer que las partes no sumen el total.</p>
        </Card>
      )}
      <ReportsDetail id="reports-costs-detail">
        {view.detail.map((section) => <ReportsSection icon="coins" key={section.key} onNavigate={onNavigate} section={section} tone="highlight" />)}
      </ReportsDetail>
      <ReportsNotes notes={view.notes} />
    </>
  );
}
